import Vue from 'vue'
import { Form, Button, Icon, Input, Select, AutoComplete, Modal } from 'ant-design-vue'
import { FlightCitySelector } from 'ace-ui-eking'
import UserIcon from '@/components/icon'

import './css/index.less'

Vue.use(Form)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Select)
Vue.use(UserIcon)
Vue.use(AutoComplete)
Vue.prototype.$success = Modal.success
Vue.prototype.$error = Modal.error
Vue.use(FlightCitySelector)
